import { useTheme } from "../contexts/ThemeContext";

type Props = {
  label: string;
  onRemove: () => void;
  removing?: boolean;
};

/** Pastille retirable (marché, option, forex) commune aux listes de droits. */
export function Chip({ label, onRemove, removing }: Props) {
  const { t } = useTheme();
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "3px 6px 3px 10px", borderRadius: 20, fontSize: 12,
      background: t.tagBg, color: t.tagColor, fontWeight: 600,
      marginRight: 6, marginTop: 6, whiteSpace: "nowrap",
    }}>
      {label}
      <button onClick={onRemove} disabled={removing} title="Retirer" style={{
        border: "none", background: "transparent", color: t.tagColor,
        cursor: removing ? "not-allowed" : "pointer", fontSize: 13, fontWeight: 700,
        padding: "0 4px", fontFamily: "inherit", lineHeight: 1,
      }}>×</button>
    </span>
  );
}
